import { Anomalies, Anomaly, AnomalyParamsOptions } from "../models/anomalies"
import { AnomalyDataObject, AnomaliesDO } from "../models/data/anomalies";
import { TimeValueDataObject } from "../../data/data-object/graph";


const SERIES_NAME_DELIMITERS = ['_Protocol', '_CMC', '_TVL', '_MarketCap', '_USD','_Spot']
const delimitersRegex = new RegExp(SERIES_NAME_DELIMITERS.join('|'))

export const anomalySeriesNameFromDataObject = (s: Anomaly) => s.series_name.split(delimitersRegex)[0].replace(/_/g, ' ')

const anomalyBlocksFromDO = (anomaliesDO: AnomaliesDO): Anomalies[] => {
    const blocks: Anomalies[] = anomaliesDO.data_points.map((dataPoint: TimeValueDataObject) => {
        return {
            time: new Date(dataPoint.time).getTime(),
            anomalies: [{
                value: dataPoint.value,
                series_name: anomaliesDO.series_name,
                params: AnomalyParamsOptions.default,
            }] as Anomaly[]
        }
    })
    return blocks;
}

export const anomaliesListFromDataObject = (graph: AnomalyDataObject): Anomalies[] => {
    const allBlocks: Anomalies[] = graph.anomaly_series.filter(b => !b.series_name.includes('Total')).flatMap(anomalyBlocksFromDO).sort((a,b) => b.time - a.time)

    const mergedBlocks: Anomalies[] = [];
    allBlocks.forEach((block) => {
        const existingBlock = mergedBlocks.find(b => b.time === block.time);
        if (existingBlock) {
            existingBlock.anomalies.push(...block.anomalies);
        } else {
            mergedBlocks.push(block);
        }
    });

    return mergedBlocks;
}
